function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  d: "M0 0h16v16H0z"
}), React.createElement("path", {
  d: "M14 4.333a1.997 1.997 0 0 0-1.993 2.14l-1.354.454A2.979 2.979 0 0 0 8.507 5.38V3.94A2.012 2.012 0 0 0 10 2c0-1.107-.893-2-2-2S6 .893 6 2c0 .933.64 1.713 1.5 1.94v1.44c-.933.153-1.72.74-2.147 1.547l-1.36-.454C4 6.427 4 6.38 4 6.333c0-1.106-.893-2-2-2s-2 .894-2 2c0 1.107.893 2 2 2 .707 0 1.32-.366 1.68-.913l1.353.453a3.01 3.01 0 0 0 .727 2.46l-.94 1.18A1.997 1.997 0 0 0 2 13.333c0 1.107.893 2 2 2s2-.893 2-2c0-.453-.147-.866-.4-1.2l.94-1.18a3 3 0 0 0 2.913 0l.94 1.18a2.006 2.006 0 0 0-.393 1.2c0 1.107.893 2 2 2s2-.893 2-2c0-1.106-.893-2-2-2-.293 0-.567.06-.82.174l-.94-1.18c.62-.694.86-1.6.727-2.46l1.353-.454c.353.547.973.914 1.68.914a1.997 1.997 0 1 0 0-3.994zM2 7a.669.669 0 0 1-.667-.667c0-.366.3-.666.667-.666.367 0 .667.3.667.666C2.667 6.7 2.367 7 2 7zm2 7a.669.669 0 0 1-.667-.667c0-.366.3-.666.667-.666.367 0 .667.3.667.666 0 .367-.3.667-.667.667zM7.333 2c0-.367.3-.667.667-.667.367 0 .667.3.667.667 0 .367-.3.667-.667.667A.669.669 0 0 1 7.333 2zM8 10a1.667 1.667 0 1 1 .001-3.335A1.667 1.667 0 0 1 8 10zm4 2.667c.367 0 .667.3.667.666 0 .367-.3.667-.667.667a.669.669 0 0 1-.667-.667c0-.366.3-.666.667-.666zM14 7a.669.669 0 0 1-.667-.667c0-.366.3-.666.667-.666.367 0 .667.3.667.666 0 .367-.3.667-.667.667z",
  fill: "#323C47"
}));

var SvgIconCdn = function SvgIconCdn(props) {
  return React.createElement("svg", _extends({
    width: 16,
    height: 16
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/icon_cdn.76ded498.svg";
export { SvgIconCdn as ReactComponent };